import React from "react";

const RegistrationMode = ({ onEnquiry, onRegister }) => {
  return (
    <div className="card">
      <div className="card-body text-center py-5">
        <h3>Choose Registration Type</h3>

        <p>Select how you would like to proceed.</p>

        <div className="d-flex gap-3 justify-content-center">
          <button className="btn btn-primary" onClick={onEnquiry}>
            Enquiry
          </button>

          <button className="btn btn-success" onClick={onRegister}>
            Register
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegistrationMode;
